export interface IInventoryTemplateItemGroup {
  itemGroupId: string;
  itemGroupName: string;
  itemGroupInstructions: string;
  isActive: boolean;
}
